import { connect } from 'react-redux';
import { changeHeatingSourceTypeFilter } from '../../../../store/filters/actions';
import { createExtraFilter, IExtraFilterProps } from '../helpers';
import { mapDispatchToPropsCreator, mapStateToPropsCreator } from '../creators';
import { HEATING_SOURCES } from '../../../../constants/filters';
import { EHeatingSource } from '../../../../types/filters';

export const HeatingSourceTypeLongNames: { [key: string]: string } = {
  coal: 'Отопление: угольное',
  fireplace: 'Отопление: камин',
  gas: 'Отопление: газовое',
  stove: 'Отопление: печь',
  without: 'Без отопления',
};

const HeatingSourceTypeFilter = createExtraFilter<EHeatingSource>(HEATING_SOURCES);

type EHeatingSourceTypeFilterProps = IExtraFilterProps<EHeatingSource>;

export const HeatingSourceTypeFilterContainer = connect<
  Pick<EHeatingSourceTypeFilterProps, 'selected'>,
  Pick<EHeatingSourceTypeFilterProps, 'toggle'>
>(
  mapStateToPropsCreator<EHeatingSource>('heatingSourceType'),
  mapDispatchToPropsCreator<EHeatingSource>(changeHeatingSourceTypeFilter),
)(HeatingSourceTypeFilter);
